// extracted by mini-css-extract-plugin
export default {"cls1":"dR5fi3H6mI8yccDFuDHw","cls2":"snYTim3maCgHaaFrXnVZ dR5fi3H6mI8yccDFuDHw"};